<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">
      <div class="row">
        <div class="col">
          <input-v
            v-model="handleObjetivo"            
            :label="{
              name: 'Objetivo',
              labelBold: true,
              type: 'richtext',
              rules: [{ rule: 'max', params: { size: 50000 } }],
              counter: 50000,
              maxLength: 50000
            }"            
            :editable="false"
          >
          </input-v>
        </div>        
      </div> 
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.descricao_li"
            :valid.sync="fieldsComputed.descricao_li.valid"
            :label="fieldsComputed.descricao_li"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.elemento_tecnologico_li"
            :valid.sync="fieldsComputed.elemento_tecnologico_li.valid"
            :label="fieldsComputed.elemento_tecnologico_li"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.desafio_tecnologico_li"
            :valid.sync="fieldsComputed.desafio_tecnologico_li.valid"
            :label="fieldsComputed.desafio_tecnologico_li"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>    
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LIEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
  },
  data() { 
    return {
      fields,
    }
  },
  computed: {
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.objetivos);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
    handleObjetivo: function() {
      return `${this.projeto.descricao_li || ''} </br> ${this.projeto.elemento_tecnologico_li || ''} </br> ${this.projeto.desafio_tecnologico_li || ''}`;
    }
  },
  methods: {
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
</style>